import axios from "axios";
import { expireIframeSession, isInIframe } from "./utils/authSession";

// export const BASE_API_URL_IMPORTER = "https://prod-greenback-app-importer.azurewebsites.net/api";
// export const BASE_API_URL_IMPORTER = "https://dev-greenback-app-importer.azurewebsites.net/api";
// export const BASE_API_URL_IMPORTER = "https://localhost:7288/api";
export const BASE_API_URL_IMPORTER = process.env.REACT_APP_IMPORTER_API_URL;

const getApiKey = () => {
  return window.location.href.includes("prod")
    ? "AIzaSyA_wI3Cbepyi68qj9y7Cm1KLlBub8PhMNQ"
    : "AIzaSyDjEbvbB3xI2ZrHOYabTdl1DNaRzz2Yl80";
};

const refreshAuthToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return null;

  try {
    const response = await axios.post(
      `https://securetoken.googleapis.com/v1/token?key=${getApiKey()}`,
      new URLSearchParams({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
      }),
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    const { id_token, refresh_token } = response.data;
    localStorage.setItem("authToken", id_token);
    localStorage.setItem("refreshToken", refresh_token);
    return id_token;
  } catch {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    return null;
  }
};

const axiosInstanceImporter = axios.create({
  baseURL: BASE_API_URL_IMPORTER,
});

axiosInstanceImporter.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let pendingRequests = [];

axiosInstanceImporter.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isInIframe()) {
        expireIframeSession();
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingRequests.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstanceImporter(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshAuthToken();
        if (newToken) {
          pendingRequests.forEach(({ resolve }) => resolve(newToken));
          pendingRequests = [];
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosInstanceImporter(originalRequest);
        }
      } catch {
        pendingRequests.forEach(({ reject }) => reject(error));
        pendingRequests = [];
      } finally {
        isRefreshing = false;
      }

      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosInstanceImporter;
